// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1516227481813
      var cssReload = require("../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  


//////////////////
// WEBPACK FOOTER
// ./components/card/card.scss
// module id = 97
// module chunks = 0